module.exports = __webpack_public_path__ + "img/bt.8bd7c02a.png";